// Get your API key from Google Cloud Console: https://console.cloud.google.com/google/maps-apis/credentials
// Enable the Maps JavaScript API and Places API
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export const defaultMapCenter = {
  lat: 40.7128, // New York City coordinates as default
  lng: -74.0060
};

export const defaultMapZoom = 12;

export const mapOptions = {
  mapTypeControl: true,
  streetViewControl: false,
  fullscreenControl: true,
  styles: [] // Add custom map styles here if needed
};
